'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _RetirementPlanListFFF = require('./RetirementPlanListFFF.css');

var _RetirementPlanListFFF2 = _interopRequireDefault(_RetirementPlanListFFF);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RetirementPlanList = (_dec = (0, _reactCssModules2.default)(_RetirementPlanListFFF2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(RetirementPlanList, _Component);

  function RetirementPlanList() {
    (0, _classCallCheck3.default)(this, RetirementPlanList);
    return (0, _possibleConstructorReturn3.default)(this, (RetirementPlanList.__proto__ || (0, _getPrototypeOf2.default)(RetirementPlanList)).apply(this, arguments));
  }

  (0, _createClass3.default)(RetirementPlanList, [{
    key: 'render',
    value: function render() {
      var companies = (0, _keys2.default)(_config2.default.planNames).map(function (key, i) {
        return {
          company: _config2.default.planNames[key].short_name,
          logo: require('../../../static/images/plans/' + _config2.default.planNames[key].path + '.png'),
          path: key
        };
      });

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'cs-out' },
        _react2.default.createElement(
          'div',
          { styleName: 'cs-tl-sub' },
          'Select a company retirement plan'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'pos-rel' },
          _react2.default.createElement(
            'div',
            { styleName: 'company-picker-flex' },
            companies.map(function (e, i) {
              return _react2.default.createElement(
                'h3',
                {
                  key: 'cmpny-' + i,
                  styleName: 'company-picker-cell company-picker-actv'
                },
                _react2.default.createElement(
                  _.Link,
                  {
                    to: _config2.default.links.iyvPlans + '/' + e.path,
                    title: e.company
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'company-picker-cell-inner' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'company-picker-cell-grow' },
                      _react2.default.createElement('img', {
                        src: e.logo,
                        alt: e.company,
                        styleName: 'company-picker-img'
                      })
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return RetirementPlanList;
}(_react.Component)) || _class);
exports.default = RetirementPlanList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RetirementPlanListFFF/RetirementPlanListFFF.js
// module id = 1387
// module chunks = 0